// src/pages/StudentsProfilePage.jsx
import React, { useEffect, useState } from "react";
import StaffSidebar from "../components/StaffSidebar";
import axios from "axios";
import Pagination from "../components/Pagination";
import Modal from "react-modal";
import "../assets/css/staff-dashboard.css";

Modal.setAppElement("#root");

export default function StudentsProfilePage() {
  const programme = localStorage.getItem("programme");
  const API = process.env.REACT_APP_API_BASE_URL || "http://localhost:3003";
  const PAGE_SIZE = 12;
  const LEVELS = [
    "All",
    "ND1",
    "ND2",
    "HND1",
    "HND2",
    "Postgraduate",
    "Diploma",
  ];

  // student list state
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [level, setLevel] = useState("All");
  const [page, setPage] = useState(1);

  // modal/profile state
  const [modalOpen, setModalOpen] = useState(false);
  const [profile, setProfile] = useState(null);

  // fetch students
  useEffect(() => {
    if (!programme) return;
    axios
      .get(`${API}/api/staff/students`, {
        params: {
          programme,
          level: level === "All" ? "" : level,
          search: search.trim(),
        },
      })
      .then((res) => {
        setStudents(res.data);
        setPage(1);
      })
      .catch(console.error);
  }, [API, programme, level, search]);

  // open profile modal
  const openProfile = (studentId) => {
    axios
      .get(`${API}/api/staff/student/${studentId}`)
      .then((res) => {
        setProfile(res.data);
        setModalOpen(true);
      })
      .catch((err) => {
        console.error("Failed to load profile:", err);
        alert("Could not load student profile.");
      });
  };

  // pagination
  const totalPages = Math.ceil(students.length / PAGE_SIZE);
  const paged = students.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="staff-dashboard" style={{ marginTop: "-130px" }}>
      <StaffSidebar />

      <main>
        <h1>Manage Students</h1>

        <div className="controls">
          <input
            type="search"
            placeholder="Search students…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <select value={level} onChange={(e) => setLevel(e.target.value)}>
            {LEVELS.map((lvl) => (
              <option key={lvl} value={lvl}>
                {lvl}
              </option>
            ))}
          </select>
        </div>

        <ul className="list modern">
          {paged.map((s) => (
            <li key={s.id}>
              <div>
                <strong>{s.fullName}</strong>
                <span> ({s.matricNumber})</span>
              </div>
              <div>
                <span className="lvl-tag">{s.Level}</span>
                <button className="btn-view" onClick={() => openProfile(s.id)}>
                  Profile
                </button>
              </div>
            </li>
          ))}
        </ul>

        <Pagination page={page} total={totalPages} onChange={setPage} />

        <Modal
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          className="modal modern"
          overlayClassName="overlay"
        >
          <button className="modal-close" onClick={() => setModalOpen(false)}>
            ×
          </button>

          {profile ? (
            <div className="profile">
              <h2>{profile.FullName || profile.fullName}</h2>
              <p>
                <strong>Matric No:</strong>{" "}
                {profile.MatricNumber ||
                  profile.matricNumber ||
                  profile.MatricNo}
              </p>
              <p>
                <strong>Level:</strong> {profile.Level || profile.level}
              </p>
              <p>
                <strong>Department:</strong>{" "}
                {profile.Department ||
                  profile.department ||
                  profile.DepartmentName}
              </p>
              <p>
                <strong>Email:</strong> {profile.Email || profile.email}
              </p>
              {/* <p>
                <strong>Phone:</strong> {profile.Phone || profile.phoneNumber}
              </p> */}
            </div>
          ) : (
            <p>Loading…</p>
          )}
        </Modal>
      </main>
    </div>
  );
}
